export enum HotColdSectorType {
    HOT = 'hot',
    COLD = 'cold',
}
